import { publicUrlFor } from "../../../../globals/constants";
import { NavLink } from "react-router-dom";

function SectionSlider1() {
  return (
    <>
      {/* HERO BANNER */}
      <div
        className="sx-bnr-1-wrap overlay-overlay"
        style={{
          backgroundImage: `url(${publicUrlFor(
            "images/main-slider/slider1/slide1.jpg"
          )})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "85vh",
          display: "flex",
          alignItems: "center",
          backfaceVisibility: "hidden",
          backgroundBlendMode: "multiply",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
        }}
      >
        <div className="sx-bg-overlay opacity-0 sx-bg-primary" />

        <div className="container">
          <div className="sx-bnr-1-content text-center">
            {/* H1 */}
            <h1
              style={{ fontSize: "7vw" }}
              className="sx-bnr-1-large-title fw-bolder text-light mb-3"
            >
              DArchTech, Your Digital Growth Partner
            </h1>

            {/* H2 */}
            <h2 className="sx-bnr-1-info fs-4 text-light mb-4">
              Powering Digital Growth Through Design, Development & Marketing
            </h2>

            {/* CTA */}
            <div className="sx-bnr-readmore mt-4">
              <NavLink
                to="/contact-us"
                className="site-button sx-btn-primary icon"
              >
                Request A Call
              </NavLink>
            </div>
          </div>
        </div>

        {/* Masked Background Text */}
        <div className="sx-bnr-text-masking">
          <div className="light">
            <h1 className="animate-charcter">Web Solutions</h1>
          </div>
        </div>
      </div>

      {/* CONTENT SECTION AFTER BANNER */}
      <section className="pt-5 bg-white">
        <div className="container" style={{ maxWidth: "1000px" }}>
          {/* Centered Heading */}
          <div className="text-center mb-4">
            <h2 className="fw-bold text-dark fs-1">
              Build Digital Experiences That Drive Results
            </h2>
          </div>

          {/* Description */}
          <p className="text-secondary text-center lh-lg fs-6 ">
            DArch Tech is a technology-driven digital solutions company helping
            businesses build, grow, and scale their online presence. We work
            closely with brands to understand their goals and deliver
            innovative, reliable, and result-oriented digital solutions that
            support long-term growth
          </p>
          <p className="text-secondary text-center lh-lg fs-6 mb-5">
            Our approach focuses on strategy, creativity, and technology to
            create meaningful digital experiences that add real value to
            businesses across industries. With a strong emphasis on quality,
            transparency, and performance, we aim to be a trusted digital
            partner for our clients.
          </p>
        </div>
      </section>
    </>
  );
}

export default SectionSlider1;
